import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ChatPage } from 'src/shared/components/chat/chat.page';
import { ChatItemModel, ChatItemStyle, ChatItemType } from 'src/shared/models/chat/chat-item.model';
import { ChatModel, ChatType } from 'src/shared/models/chat/chat.model';
import { ModalProvider } from './modal.provider';

@Injectable({ providedIn: 'root' })
export class ChatProvider {

    private readonly _items = new BehaviorSubject<Array<ChatItemModel>>([]);
    public readonly items$ = this._items.asObservable();

    static MODEL = {
        ID: "Id",
        TITLE: "Title",
        TYPE: "Type",
    };

    constructor(
        private modalProdiver: ModalProvider,
    ) { }

    async open(model: ChatModel, chatType: ChatType, closeChatCallback?: () => void) {
        const title = model.title;

        this._items.next(model.items);

        const modal = await this.modalProdiver.openModal(
            {
                component: ChatPage,
                componentProps: {
                    [ChatProvider.MODEL.ID]: model.id,
                    [ChatProvider.MODEL.TITLE]: title,
                    [ChatProvider.MODEL.TYPE]: chatType,
                },
            },
        );

        modal.onWillDismiss().then(() => {
            if (closeChatCallback) closeChatCallback();
        });
    }

    appendNewMessage(message: ChatItemModel) {
        const items = [...(this._items.value || []), message];

        this._items.next(items);
    }

    appendLocalChatMessage(username?: string, title?: string, message?: string, style?: ChatItemStyle) {
        const chatItem: ChatItemModel = {
            createdAt: new Date(),
            fromClient: true,
            username: username,
            title: title,
            style: style,
            message: message,
            itemType: ChatItemType.Message
        };

        const items = [...(this._items.value || []), chatItem];

        this._items.next(items);
    }
}